<template>
  <div
    v-if="showIntegrationsSection"
    class="lead-detail-integration-actions px-4 pb-2"
  >
    <v-divider class="mb-3" />
    <div class="text-overline grey--text text--darken-1 mb-2">
      Integraciones
    </div>
    <div v-if="showZoomCollectAction">
      <v-btn
        color="primary"
        outlined
        small
        :loading="zoomCollectLoading"
        @click="sendZoomCollectEvent"
      >
        <v-icon left small>mdi-video</v-icon>
        Agendó zoom
      </v-btn>
    </div>
    <v-divider class="mt-5" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { RunLeadIntegration } from "@/api/lead-api";
import { ZOOM_COLLECT_REAL_ESTATE_GROUP_IDS } from "@/constants/integrations/zoom";

export default {
  name: "LeadDetailIntegrationActions",
  props: {
    lead: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      zoomCollectLoading: false
    };
  },
  computed: {
    ...mapState({
      realEstateGroup: state => state.realEstateGroup.realEstateGroup
    }),
    showIntegrationsSection() {
      return this.showZoomCollectAction;
    },
    showZoomCollectAction() {
      return ZOOM_COLLECT_REAL_ESTATE_GROUP_IDS.includes(
        this.realEstateGroup?._id
      );
    }
  },
  methods: {
    async sendZoomCollectEvent() {
      this.zoomCollectLoading = true;
      try {
        const response = await RunLeadIntegration({
          leadId: this.lead._id,
          integration: "zoom"
        });
        if (response.Data?.integrationSuccess) {
          this.$snotify.success(response.Message);
        } else {
          this.$snotify.warning(response.Message);
        }
      } catch (error) {
        this.$snotify.error("No se pudo ejecutar la integración Zoom");
      } finally {
        this.zoomCollectLoading = false;
      }
    }
  }
};
</script>
